<div class="col-md-12 mb-3 search-bar" style="margin-left:0" [matTooltip]="tooltip">
    <ng-container *ngIf="isLoading">
        <div class="form-control" style="width: 100%; background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); background-size: 200% 100%; animation: loading 1.5s infinite;">
            <div style="height: 20px; width: 60%;"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="!isLoading">
        <input
            type="text"
            class="form-control"
            [placeholder]="placeholder"
            style="width:100%;"
            matInput
            [formControl]="control"
            [matAutocomplete]="auto"
            [value]="displayFn(control.value)"
        >
        <i class="fa fa-chevron-down search-icon"></i>

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
            <div class="help-text" *ngIf="auto.isOpen">
                <i class="fa fa-info-circle"></i>
                Digite para filtrar ou selecione uma opção da lista
            </div>
            <ng-container *ngIf="filteredOptions | async as options">
                <mat-option *ngFor="let option of options" [value]="option" class="modern-option">
                    <div class="option-content">
                        <span class="option-text">{{option[displayProperty]}}</span>
                        <span *ngIf="option['description']" class="option-description">{{option['description']}}</span>
                    </div>
                </mat-option>
            </ng-container>
        </mat-autocomplete>
    </ng-container>
</div> 